// src/web/components/attachments-page.jsx

import React from 'react'
import ReactDOM from 'react-dom'
import connect from '../../connects/attachments-page'
import RightSidePage from './right-side-page.jsx'
import Loading from './loading.jsx'
import _ from 'lodash'
import VideoViewer from './video-viewer.jsx'

function isVideo(video) {
  return video.content_type.match(/^video/) && (video.status == 'committed')
}

class AttachmentsPage extends React.Component {
  showImagesView = (image)=> {
    this.props.showImagesView('GROUP_TIMELINE', this.props.params.diary_id, image)
  }

  onClick = (image)=> {
    this.showImagesView(image)
  }
  
    render() {
    const {
      t,
      params,
      files,
      images,
      videos,
      isFetching,
      isFetchFailed,
      showImagesView,
    } = this.props

    return (
      <RightSidePage title={t('label:添付ファイル')} icon="photo_library">
        {!isFetchFailed && isFetching && <Loading />}
        {!isFetchFailed && !isFetching && !params.file && images && images.length > 0 && _.map(images, (image, i)=> 
        <div key={image.file_id}>
          <span style={{ margin: '0 0 5px 30px'}}>{image.name}</span>
          <img key={image.file_id} 
            src={image.file.url}
            style={{ maxWidth: '100%', display: 'block', margin: '3px auto', cursor: 'pointer', marginBottom: '30px', paddingRight: '30px', paddingLeft: '30px' }}
            onClick={()=> this.showImagesView(image)} />
        </div>
        )}
        {!isFetchFailed && !isFetching && !params.file && videos && videos.length > 0 && _.map(videos, (video, i)=>
          <div key={video.video_id} style={{ marginBottom: '30px' }}>
            <VideoViewer video={video} t={t} parent_component={'ATTACHMENTS_PAGE'} params={params} />
          </div>
        )}
        {!isFetchFailed && !isFetching && params.file &&
          <div key={params.file.video_id} style={{ marginBottom: '20px' }}>
            <span style={{ display: 'block',textAlign: 'center'}}>{params.file.name}</span>
            <VideoViewer video={params.file} t={t} parent_component={'ATTACHMENTS_PAGE'} params={params} />
          </div>
        }
        {isFetchFailed && 
          <div style={{ marginTop: '10px', textAlign: 'center'}}>{t('label:添付ファイルの取得に失敗しました')}</div>
        }
      </RightSidePage>
    )
  }
}

export const RawAttachmentsPage = AttachmentsPage
export default connect(AttachmentsPage)



// WEBPACK FOOTER //
// ./src/web/components/attachments-page.jsx